import styled from "styled-components";

import { size } from "@styles/Utilities.styled";


export const StyledWithSidebar = styled.div`
  position: fixed;
  top: 0;
  left: var(--sidebar-width);
  width: calc(100% - var(--sidebar-width));
  height: calc(100% - var(--footer-height));
  padding-inline: 1rem;
  /* outline: 3px solid red; */

  &.has-patient-navbar {
    top: var(--patient-navbar-height);
  }

  &.has-dashboard-navbar {
    top: var(--dashboard-navbar-height);
  }

  .scroll-area-wrapper {
    ${size("100%")}
    transition: transform var(--network-notification-transition-duration);

    &.show-notification {
      transform: translateY(var(--network-notification-height));
    }

    &.hide-notification {
      transform: translateY(0);
      transition-delay: var(--network-notification-dismiss-delay);
    }
  }
`;
